export default "__VITE_ASSET__BSSQWDPp__"